// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsLetter {
    border-radius: 16px;
    background: #FFFFFF;
    color: #333333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    border: 1px solid #FCCC4D;
}

.NewsLetter:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.NewsLetter .title {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0.8rem;
    line-height: 1.2;
    color: #DC6803;
    text-shadow: none;
}

.NewsLetter .subtitle {
    font-size: 1rem;
    font-weight: 500;
    padding: 8px 0;
    color: #666666;
    margin-bottom: 1.5rem;
    line-height: 1.6;
    max-width: 90%;
}

.content-section {
    flex: 1 1;
    padding-right: 2rem;
    position: relative;
    z-index: 1;
}

.img-section {
    flex: 0.6 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.img-section img {
    max-width: 90%;
    height: auto;
    transition: transform 0.5s ease;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.08));
}

.img-section:hover img {
    transform: scale(1.02);
}

.subscribe {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    position: relative;
}

/* Add decorative elements */
.NewsLetter::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(252, 204, 77, 0.1) 0%, rgba(252, 204, 77, 0) 70%);
    border-radius: 50%;
    transform: translate(30%, -30%);
}

@media (max-width: 1024px) {
    .NewsLetter {
        padding: 1.5rem 2rem;
    }

    .NewsLetter .title {
        font-size: 1.8rem;
    }
}

@media (max-width: 768px) {
    .NewsLetter {
        flex-direction: column;
        text-align: center;
        padding: 1.5rem;
    }

    .content-section {
        padding-right: 0;
        margin-bottom: 1.5rem;
    }

    .NewsLetter .subtitle {
        margin: 0.8rem auto 1.5rem;
    }

    .subscribe {
        justify-content: center;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .img-section {
        display: none; /* Hide image on mobile for more compact view */
    }
}

@media (max-width: 480px) {
    .NewsLetter {
        padding: 1rem;
        border-radius: 12px;
    }

    .NewsLetter .title {
        font-size: 1.5rem;
    }

    .NewsLetter .subtitle {
        font-size: 0.9rem;
        margin-bottom: 1rem;
    }

    .subscribe {
        flex-direction: column;
        gap: 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/newsLetter/newsLetter.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,+BAA+B;IAC/B,mDAAmD;AACvD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,0FAA0F;IAC1F,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa,EAAE,+CAA+C;IAClE;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;AACJ","sourcesContent":[".NewsLetter {\n    border-radius: 16px;\n    background: #FFFFFF;\n    color: #333333;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2rem;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n    transition: all 0.3s ease;\n    overflow: hidden;\n    position: relative;\n    border: 1px solid #FCCC4D;\n}\n\n.NewsLetter:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n}\n\n.NewsLetter .title {\n    font-size: 2rem;\n    font-weight: 800;\n    margin-bottom: 0.8rem;\n    line-height: 1.2;\n    color: #DC6803;\n    text-shadow: none;\n}\n\n.NewsLetter .subtitle {\n    font-size: 1rem;\n    font-weight: 500;\n    padding: 8px 0;\n    color: #666666;\n    margin-bottom: 1.5rem;\n    line-height: 1.6;\n    max-width: 90%;\n}\n\n.content-section {\n    flex: 1;\n    padding-right: 2rem;\n    position: relative;\n    z-index: 1;\n}\n\n.img-section {\n    flex: 0.6;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n.img-section img {\n    max-width: 90%;\n    height: auto;\n    transition: transform 0.5s ease;\n    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.08));\n}\n\n.img-section:hover img {\n    transform: scale(1.02);\n}\n\n.subscribe {\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    position: relative;\n}\n\n/* Add decorative elements */\n.NewsLetter::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 200px;\n    height: 200px;\n    background: radial-gradient(circle, rgba(252, 204, 77, 0.1) 0%, rgba(252, 204, 77, 0) 70%);\n    border-radius: 50%;\n    transform: translate(30%, -30%);\n}\n\n@media (max-width: 1024px) {\n    .NewsLetter {\n        padding: 1.5rem 2rem;\n    }\n\n    .NewsLetter .title {\n        font-size: 1.8rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .NewsLetter {\n        flex-direction: column;\n        text-align: center;\n        padding: 1.5rem;\n    }\n\n    .content-section {\n        padding-right: 0;\n        margin-bottom: 1.5rem;\n    }\n\n    .NewsLetter .subtitle {\n        margin: 0.8rem auto 1.5rem;\n    }\n\n    .subscribe {\n        justify-content: center;\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n\n    .img-section {\n        display: none; /* Hide image on mobile for more compact view */\n    }\n}\n\n@media (max-width: 480px) {\n    .NewsLetter {\n        padding: 1rem;\n        border-radius: 12px;\n    }\n\n    .NewsLetter .title {\n        font-size: 1.5rem;\n    }\n\n    .NewsLetter .subtitle {\n        font-size: 0.9rem;\n        margin-bottom: 1rem;\n    }\n\n    .subscribe {\n        flex-direction: column;\n        gap: 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
